import i18n from "../../../../Frontends/Common/utils/i18n";
export class StatusService {
  constructor() {
    this.statuses = [
      { text: i18n.global.t("planStatus"), status: "plan" },
      { text: i18n.global.t("draftStatus"), status: "draft" },
      { text: i18n.global.t("planFactStatus"), status: "planFact" },
    ];
  }
  search(value) {
    return this.statuses.filter((elem) => elem.text.indexOf(value) !== -1);
  }
  async get() {
    return Promise.resolve({ data: { records: this.statuses } });
  }
}
